import { Button, Form, notification, Popconfirm } from "antd";
import React, { useState } from "react";
import { MultiLanguageInput } from "../../../Components/MultiLanguageInput";
import { PiPlus } from "react-icons/pi";
import { addNewBettingWebsite } from "../action";

type Props = {
  fetchData: () => void;
};
interface FormValues {
  title: {
    en: string;
    ar: string;
    fr: string;
  };
}
const AddNewBettingWebsite = (props: Props) => {
  const [form] = Form.useForm<FormValues>();
  const [api, contextHolder] = notification.useNotification();
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async () => {
    try {
      const formValues = await form.validateFields();
      setIsLoading(true);

      const data = await addNewBettingWebsite(formValues.title);

      if (data) {
        form.resetFields();
        props.fetchData();
        api.success({
          message: "Betting website added successfully",
        });
      }
    } catch (err: any) {
      api.error({
        message: "Failed to add betting website",
        description:
          err?.response?.errors?.[0]?.message ||
          err?.message ||
          "Unexpected error occurred",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Form form={form} layout="vertical">
      {contextHolder}

      <MultiLanguageInput name="title" label="Title" />

      <Form.Item shouldUpdate>
        {() => (
          <Popconfirm
            title="Are you sure you want to add this betting website?"
            onConfirm={handleSubmit}
            okText="Yes"
            cancelText="No"
          >
            <Button
              icon={<PiPlus />}
              loading={isLoading}
              type="primary"
              className="w-full"
              disabled={
                !form.isFieldsTouched(true) ||
                form.getFieldsError().some(({ errors }) => errors.length > 0)
              }
            >
              {isLoading ? "Adding Betting Website..." : "Add Betting Website"}
            </Button>
          </Popconfirm>
        )}
      </Form.Item>
    </Form>
  );
};

export default AddNewBettingWebsite;
